import { render, staticRenderFns } from "./collapsed-card.vue?vue&type=template&id=33464364"
import script from "./collapsed-card.vue?vue&type=script&lang=js"
export * from "./collapsed-card.vue?vue&type=script&lang=js"
import style0 from "./collapsed-card.vue?vue&type=style&index=0&id=33464364&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports